import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { PositionResponse } from '@/main/models/response';
import { PositionRequest } from '@/main/models/request/positionRequest';

export abstract class IPositionApi {
  abstract getPosition(
    request: PositionRequest
  ): Promise<AxiosResponse<Result<PositionResponse[]>>>;
  abstract getPositionWithIdPIES(
    request: PositionRequest
  ): Promise<AxiosResponse<Result<PositionResponse[]>>>;
}

